const stageClass = {
  new: 'bg-slate-100 text-slate-700',
  assigned: 'bg-indigo-100 text-indigo-700',
  contacted: 'bg-blue-100 text-blue-700',
  qualified: 'bg-purple-100 text-purple-700',
  proposal_sent: 'bg-amber-100 text-amber-700',
  won: 'bg-green-100 text-green-700',
  lost: 'bg-rose-100 text-rose-700',
  archived: 'bg-gray-200 text-gray-700',
}

const LeadStageBadge = ({ stage = 'new', t }) => {
  return <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-semibold ${stageClass[stage] || stageClass.new}`}>{t ? t(`crm.stages.${stage}`) : stage}</span>
}

export default LeadStageBadge
